import React from 'react'

/**
 * Aviso no bloqueante de inactividad. No fuerza navegación del editor.
 */
const SessionExpiryBanner = ({ mode, remainingLabel, onContinue, onLogout }) => {
  if (!mode) return null

  const isWarning = mode === 'warning'
  const isExpired = mode === 'expired'

  return (
    <div
      role="alert"
      className={`fixed z-[10000] left-1/2 -translate-x-1/2 top-4 max-w-lg w-[calc(100%-2rem)] rounded-lg shadow-lg border px-4 py-3 ${
        isExpired
          ? 'bg-red-50 border-red-300 text-red-900'
          : 'bg-amber-50 border-amber-300 text-amber-900'
      }`}
    >
      <div className="font-semibold text-sm mb-1">
        {isWarning ? 'Tu sesión está por expirar' : 'Sesión expirada por inactividad'}
      </div>
      <p className="text-xs mb-3">
        {isWarning
          ? `Por seguridad, la sesión se cerrará por inactividad${remainingLabel ? ` en ${remainingLabel}` : ''}. Mueve el mouse o pulsa una tecla para continuar.`
          : 'Debes iniciar sesión de nuevo. Al volver, carga tu documento desde cero; no se restauran borradores del editor.'}
      </p>
      <div className="flex flex-wrap gap-2 justify-end">
        {isWarning && (
          <button
            type="button"
            onClick={onContinue}
            className="px-3 py-1.5 text-xs font-medium rounded-md bg-amber-600 text-white hover:bg-amber-700"
          >
            Seguir trabajando
          </button>
        )}
        <button
          type="button"
          onClick={onLogout}
          className={`px-3 py-1.5 text-xs font-medium rounded-md border ${
            isExpired
              ? 'bg-red-600 text-white border-red-700 hover:bg-red-700'
              : 'bg-white text-amber-900 border-amber-400 hover:bg-amber-100'
          }`}
        >
          {isExpired ? 'Ir a iniciar sesión' : 'Cerrar sesión'}
        </button>
      </div>
    </div>
  )
}

export default SessionExpiryBanner
